import React from "react";
import { Crosshair, Cpu, ShieldCheck } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
const philosophies = [{
  title: "Transparency",
  description: "Clear reporting, visible performance data, and honest communication are central to how Imperium Technologies operates. Trust is built through evidence, not promises.",
  icon: ShieldCheck
}, {
  title: "Precision",
  description: "Our systems are built around structure, disciplined execution logic, and repeatable decision-making. Precision is approached as an operational standard, not a marketing claim.",
  icon: Cpu
}, {
  title: "Risk Control",
  description: "We believe longevity in trading comes from disciplined risk management and controlled exposure. Capital preservation remains a foundational principle of the brand.",
  icon: Crosshair
}];
export default function CorePhilosophies() {
  return <section data-section-id="102805" id="core-values" className="dark bg-background text-foreground relative overflow-hidden py-24 lg:py-32">
      {}
      <svg className="absolute inset-0 w-full h-full pointer-events-none z-0 opacity-20" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <pattern id="circuit-pattern" x="0" y="0" width="80" height="80" patternUnits="userSpaceOnUse">
            <path d="M40 40 L80 40 M40 40 L40 80 M40 40 L0 40 M40 40 L40 0 M20 20 L40 40 M60 60 L40 40 M60 20 L40 40 M20 60 L40 40" stroke="hsl(210, 100%, 55%)" strokeWidth="0.5" fill="none" />
            <circle cx="40" cy="40" r="1.5" fill="hsl(210, 100%, 55%)" />
            <circle cx="80" cy="40" r="1" fill="hsl(210, 100%, 55%)" />
            <circle cx="40" cy="80" r="1" fill="hsl(210, 100%, 55%)" />
            <circle cx="0" cy="40" r="1" fill="hsl(210, 100%, 55%)" />
            <circle cx="40" cy="0" r="1" fill="hsl(210, 100%, 55%)" />
          </pattern>
        </defs>
        <rect x="0" y="0" width="100%" height="100%" fill="url(#circuit-pattern)" />
      </svg>

      {}
      <div className="absolute top-0 left-1/4 w-96 h-96 bg-primary/5 rounded-full blur-[120px] pointer-events-none z-0" />
      <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-primary/5 rounded-full blur-[120px] pointer-events-none z-0" />

      <div className="container mx-auto px-4 relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold tracking-tight mb-4 text-foreground uppercase">
            Core Values
          </h2>
          <div className="h-0.5 w-24 bg-primary mx-auto rounded-full shadow-[0_0_15px_var(--color-primary)]" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-12">
          {philosophies.map((philosophy, i) => {
          const Icon = philosophy.icon;
          return <div data-index={i} key={i} className="group h-full">
                <Card className="h-full bg-white/5 backdrop-blur-xl border-border/50 rounded-xl shadow-2xl transition-all duration-500 hover:-translate-y-2 hover:border-primary/60 hover:shadow-[0_0_40px_-10px_rgba(59,130,246,0.3)] relative overflow-hidden">
                  {}
                  <div className="absolute inset-0 bg-gradient-to-b from-primary/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none" />
                  
                  <CardHeader className="pb-4 relative z-10">
                    <div className="mb-6 inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-background/80 border border-border/40 shadow-[inset_0_0_10px_rgba(255,255,255,0.05)] group-hover:border-primary/50 transition-colors duration-500">
                      <Icon className="w-8 h-8 text-primary drop-shadow-[0_0_12px_var(--color-primary)]" strokeWidth={1.5} />
                    </div>
                    <CardTitle className="text-2xl font-bold tracking-tight text-foreground">
                      {philosophy.title}
                    </CardTitle>
                  </CardHeader>
                  <CardContent className="relative z-10">
                    <p className="text-muted-foreground leading-relaxed text-left">
                      {philosophy.description}
                    </p>
                  </CardContent>
                </Card>
              </div>;
        })}
        </div>
      </div>
    </section>;
}